import React, { useState } from "react";
import "./FAQ.css";

const faqData = [
  {
    question: "Question 1",
    answer: "Answer to question 1 goes here.",
  },
  {
    question: "Question 2",
    answer: "Answer to question 2 goes here.",
  },
  {
    question: "Question 3",
    answer: "Answer to question 3 goes here.",
  },
  {
    question: "Question 4",
    answer: "Answer to question 4 goes here.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-header">
        {/* <span className="arrow">→</span> */}
        <h2 className="faq-title">Frequently Asked Questions</h2>
      </div>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item" onClick={() => toggleFAQ(index)}>
            <div className="faq-question">{item.question}</div>
            {openIndex === index && <div className="faq-answer">{item.answer}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
